// Modal Smoke Test — dev-only 橋接 plugin（client-pwa-ssr）
// ---------------------------------------------------------------------------
// Nuxt 3/4 預設不暴露 Vue app 或 Pinia 到 window，故 modal-smoke 的 driver 無法像
// Nuxt 2（window.$nuxt）那樣在 page.evaluate 裡拿到 app/store。本 plugin 只做一件事：
// 「dev build 時」把測試需要的最小鉤子掛到 window，讓 driver 能 (a) 設 vueApp 的
// warn/error handler、(b) 開關 modal、(c) 種登入態 baseline。
//
// 安全性：以 import.meta.dev 守門 —— production build（nuxt build / generate）會被
// tree-shake / early-return，window.__modalSmoke 永不存在，不影響正式產物行為。
// （`npm run host` 走 `nuxi dev`，import.meta.dev === true，[Vue warn] 也不會被 strip。）
//
// store 一律「呼叫時才」resolve（lazy），避開本 plugin 與 @pinia/nuxt 的載入順序問題；
// 在 client 端 app 初始化後，無參數的 useXStore() 會綁到 app 的 active pinia。
// ---------------------------------------------------------------------------
import { useAuthStore, AUTH_STATE } from '@/stores/auth/auth'
import { useMainStore } from '@/stores/main'
import { useUserInfoStore } from '@/stores/user/userInfo'

export default defineNuxtPlugin((nuxtApp) => {
  if (!import.meta.dev) return

  window.__modalSmoke = {
    vueApp: nuxtApp.vueApp,
    // 每個 modal 都從乾淨狀態開機：setModal(null) 不會重設 modalLoading（stores/main.js），
    // 若前一個 modal 在 onMounted 把 modalLoading 設 true 後，因冒煙節奏快、又無真 API 資料
    // 而沒走到 finally 的 setModalLoading(false) 就被關閉，殘留的 loading 會讓下一個 modal
    // 顯示 spinner backdrop / 讓 v-if="!getModalLoading" 內容不 render，導致 report 失真。
    openModal: (type) => {
      const store = useMainStore()
      store.setModalLoading(false)
      store.setModal(type)
    },
    closeModal: () => {
      const store = useMainStore()
      store.setModal(null)
      store.setModalLoading(false)
    },
    seedAuth: () => {
      useAuthStore().setAuthState(AUTH_STATE.AUTHENTICATED)
      useUserInfoStore().setUserInfo({
        account: 'demo',
        nickname: 'Demo',
        vipLevel: 1,
        balance: 1000,
        point: 100,
        avatar: '',
        phone: '0900000000',
        email: 'demo@demo.com',
      })
    },
  }
})
